export default __webpack_public_path__ + "static/char-s-54-zh-Hant-002b841dbf77b897b81378fe475f23f1.webp";